package com.kinoshazam.uiKit.components.textLabel

import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.style.TextOverflow

@Composable
fun TextLabel(
    state: TextLabelState,
    modifier: Modifier = Modifier,
) {
    when (state.text) {
        is AnnotatedString -> Text(
            modifier = modifier,
            text = state.text,
            style = state.textStyle,
            maxLines = state.maxLines,
            color = state.color,
            overflow = TextOverflow.Ellipsis,
            textAlign = state.textAlign,
        )

        is String -> Text(
            modifier = modifier,
            text = state.text,
            style = state.textStyle,
            maxLines = state.maxLines,
            color = state.color,
            overflow = TextOverflow.Clip,
            textAlign = state.textAlign,
        )
    }
}